<template>
    <div>
        <app-tabs-wrapper :default="`tab_${locales[0].id}`" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger 
                        v-for="(locale, i) in locales"
                        :key="i"
                        :name="`tab_${locale.id}`" 
                        :handle-click="toggle" 
                        :active="active"
                        v-html="locale.lang"
                    />
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content 
                        v-for="(locale, i) in locales"
                        :key="i"
                        :name="`tab_${locale.id}`" 
                        :active="active"
                    >
                        <app-field-text label="Label" v-model="item.locales[locale.id].label" />
                        <app-field-text label="Description" v-model="item.locales[locale.id].description" />
                        <app-field-text label="URL" v-model="item.locales[locale.id].url" />
                        <app-field-toggle label="Open in new tab?" v-model="item.locales[locale.id].newTab" />
                        <app-field-file
                            class="reset mt-2"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="item.locales[locale.id].image"
                            :types="{images: true, files: false}"
                        />
                    </app-tabs-content>
                </div>
        </app-tabs-wrapper>
    </div>
</template>

<script>
    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import FileField from '@/components/fields/inputs/File';

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            locales: {
                type: Array,
                required: true
            }
        },

        components: {
            'app-field-text': TextField,
            'app-field-toggle': ToggleField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-field-file': FileField
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/menu/Cta.vue